import React, { useEffect, useState,useRef } from 'react';
import { motion } from 'framer-motion';
// import { fadeIn } from '../variants';
import {fadeIn} from '../variants';

const Body = () => {
  const helloRef = useRef(null);
  const [images, setImages] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentStep, setCurrentStep] = useState(0); // For the slider
  const fullText = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    const fetchFruits = async () => {
      const response = await fetch('https://backend.goldentreefpc.com/fruits');
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      console.log('Fetched data:', data);
      setImages(data);
    };
    fetchFruits();
  }, []);

  const fetchImageDetails = async (id) => {
    try {
      const response = await fetch(`https://backend.goldentreefpc.com/fruits/${id}`);
      if (!response.ok) throw new Error('Failed to fetch image details');
      const data = await response.json();
      console.log('data=', data);
      setSelectedImage(data); // Set the fruit data, which includes the steps
      setCurrentStep(0); // Reset the slider to the first step
    } catch (error) {
      console.error('Error fetching image details:', error);
    }
  };

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      setDisplayedText(prev => prev + fullText[index]);
      index++;
      if (index === fullText.length) clearInterval(interval);
    }, 50); // Typing speed in ms

    return () => clearInterval(interval);
  }, []);

  const scrollToHello = () => {
    helloRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    if (selectedImage) {
      scrollToHello();
    }
  }, [selectedImage]);


  const handleNextStep = () => {
    if (selectedImage && selectedImage.steps && currentStep < selectedImage.steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevStep = () => {
    if (selectedImage && selectedImage.steps && currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, [selectedImage]);

  const h2Style = {
    color: 'white',
    fontSize: '2rem',
    fontWeight: 'bold',
    fontFamily: 'Poppins, sans-serif',
    textShadow: '2px 2px 10px rgba(0,0,0,0.5)',
    opacity: animate ? 1 : 0,
    transform: animate ? 'translateY(0)' : 'translateY(-20px)',
    transition: 'all 0.6s ease-in-out',
    textAlign: 'center',
    margin: '20px 0'
  };

  return images && (
    <div className="body-container">
      <div className="hero-section">
        <div className="container">
          <div className="glass-card">
          <h1 className="typing-text">Welcome to Our Website!</h1>
            <p className="typing-text2">
            {displayedText}
            <span className="cursor">|</span>
          </p>
          </div>
        </div>
      </div>

      <div className="image-gallery">
        {images.map((src, i) => (
          <motion.div
            key={i}
            variants={fadeIn('up', i * 0.2)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            className="gallery-img-wrapper"
            onClick={() => fetchImageDetails(src.id)}
          >
            <img src={src.img} alt={`img${i + 1}`} className="gallery-img" />
          </motion.div>
        ))}
      </div>
      {selectedImage && selectedImage.steps && selectedImage.steps.length > 0 && (
        <div className="selected-image-details">
         
          <div className="slider">
            <div ref={helloRef}>
              <img src={selectedImage.steps[currentStep].image} alt={`Stage ${currentStep + 1}`} className="selected-image"/>
            </div>
            <p className="animated-title">{selectedImage.name}</p>
            <div className="step-description">
              <p>{selectedImage.steps[currentStep].description}</p>
            </div>

              <div className="slider-controls">
                <span
                  className={`step-nav ${currentStep === 0 ? 'disabled' : ''}`}
                  onClick={handlePrevStep}
                >
                  {currentStep > 0 ? `← Stage ${currentStep}` : ''}
                </span>

                <span
                  className={`step-nav ${currentStep === selectedImage.steps.length - 1 ? 'disabled' : ''}`}
                  onClick={handleNextStep}
                >
                  {currentStep < selectedImage.steps.length - 1 ? `Stage ${currentStep + 2} →` : ''}
                </span>
              </div>
          </div>
        </div>
      )}
          <div class="floating-buttons">
            <a href="tel:+919503334195" class="icon-btn contact" title="Call">
              <i class="fas fa-phone"></i>
            </a>
            <a href="https://wa.me/1234567890" class="icon-btn whatsapp" title="WhatsApp" target="_blank">
              <i class="fab fa-whatsapp"></i>
            </a>
            <a href="mailto:vrushalichougule2505@gmail.com" class="icon-btn email" title="Email">
              <i class="fas fa-envelope"></i>
            </a>
          </div>
    </div>
  );
};

export default Body;

